import React, { useCallback, useContext, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import * as DONE_ONCE from '../../../constants/doneOnceJson';

function CheckForNewClients() {

    const { firebase } = useContext(FirebaseContext);

    console.log("CHECK FOR NEW CLIENTS IF TRUE DONt" + DONE_ONCE.doneOnceJson.newClientCheck);


    const CheckForNewClients = async () =>{
        

        console.log("DONE ONCE CHECK START " + DONE_ONCE.doneOnceJson.newClientCheck);
        
        var uniqueClients = [];
        var uniqueClientsFull = [];
        var clientList = [];
        var currentClientList = [];
        var newClientsToAdd = [];

        var currentUserId = firebase.auth().currentUser.uid;

        await firebase
            .database()
            .ref('/client_appointments/' + PROJECT_CODE.projectCode)
            .orderByChild('createrID')
            .equalTo(currentUserId)
            .once('value', (snapshot) => {

            snapshot.forEach((parentSnapshot) => {
                var currentTimeDate = Date.now();
                var elementTime = parentSnapshot.val().timeOfAppointment;
                var showClientUser = true;

                //null check
                if (
                    parentSnapshot.val().createUser != null &&
                    parentSnapshot.val().createUser !== undefined
                ) {
                    showClientUser = parentSnapshot.val().createUser;
                }

                var usersRefs = parentSnapshot.child('users');

                var counter = 0;

                
                usersRefs.forEach((childSnaps) => {
                    if (counter === 0) {
                        if (uniqueClients.includes(childSnaps.val().email) != true) {
                            uniqueClients.push(childSnaps.val().email);

                            var newClientForList = {
                                clientEmail: childSnaps.val().email,
                                fullName: childSnaps.val().fullName,
                                phoneNumber: childSnaps.val().phoneNumber,
                                timeOfAppointment: parentSnapshot.val().timeOfAppointment,
                                clientKey: childSnaps.key,
                                appCode: parentSnapshot.val().appointmentID,
                            };

                            clientList.push(newClientForList);

                            uniqueClientsFull.push(newClientForList);

                            console.log(
                                'adding in  ' +
                                    childSnaps.val().email +
                                    ' ' +
                                    uniqueClients.includes(childSnaps.val().email)
                            );
                        }
                    }

                    counter++;
                });

                // console.log('Client List: ' + JSON.stringify(clientList));

            
                // console.log(
                // 	'Client Detail list: ' + JSON.stringify(clientDetailList)
                // );
                
            });
        });

        var currentUserId = firebase.auth().currentUser.uid;

        var thisSalesAgentPointer;

        console.log("My id " + currentUserId);


        await firebase.database().ref("kavtek_clients/" + PROJECT_CODE.projectCode + "/salesAgents").orderByChild("createrID").equalTo(currentUserId).limitToFirst(1).once('value', (snapshot)=>{

            var snapData = snapshot.val();

            if(snapData !== null && snapData !== undefined){

                console.log("SnapData " +  JSON.stringify(snapData));

                var allKeys = Object.keys(snapData);

                //var keyToCall = snapData[allKeys[0]];

                thisSalesAgentPointer = allKeys[0];

                console.log("saveOrUpdateDocument key" + thisSalesAgentPointer);

            }
        });

        console.log("ARE WE DOING THIS MORE THAN ONCE");

        if(thisSalesAgentPointer !== null && thisSalesAgentPointer !== undefined){

            await firebase.database().ref("kavtek_clients/" + PROJECT_CODE.projectCode + "/salesAgents/" + thisSalesAgentPointer + "/myClients").once('value', (snapshot)=>{


                //console.log(JSON.stringify(snapshot.val()));
                snapshot.forEach((clientData) => {
                    var aClient = {
                        clientEmail: clientData.val().clientEmail,
                        id: clientData.key
                    };
                    console.log(" Client email " + aClient.clientEmail + " id " + aClient.id);
                    currentClientList.push(aClient);
                });


                
            });

            console.log("unique client check ");
            for(var q = 0; q < uniqueClients.length; q++){

                var addClientBool = true;

                console.log("THIS UNIQUE CLIENT " + uniqueClients[q]);

                for(var i = 0; i < currentClientList.length; i++){
                    
                    if(currentClientList[i].clientEmail === uniqueClients[q] || uniqueClients[q] === "null"){
                        addClientBool = false;
                    }
                    //onsole.log("UNIQUE CLIENTS " + uniqueClients[q] + " " + addClientBool);
                }

                if(addClientBool === true){
                    newClientsToAdd.push(uniqueClientsFull[q]);

                    console.log("new client to add " + uniqueClients[q]);

                    
                }

            }

            for(var x = 0; x < newClientsToAdd.length; x++){

                var newClientRef = firebase.database().ref("kavtek_clients/" + PROJECT_CODE.projectCode + "/salesAgents/" + thisSalesAgentPointer + "/myClients");

                var newClientPush = newClientRef.push();

                newClientsToAdd[x]['showClient'] = true;

                newClientPush.set(newClientsToAdd[x]);
            }

        }
        

    }


    CheckForNewClients();
    return(<></>);
}


export default CheckForNewClients;